import ContentCard from './ContentCard';

export default ContentCard;
